import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { donorapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchDataViewSuccess = (data: any) => ({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: data,
});

//To get list of officers data
export const fetchneeddata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid,q:1 };
            const apiname = donorapi.durgentneed;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const viewdata = (uid:any,Id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid,orgneedid:Id,q:2 };
            const apiname = donorapi.durgentneed;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};